"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _base64 = require('base-64');


 const makeRestBaseURL = ({ secure, host, port }) => {
  const protocol = secure ? 'https' : 'http'
  return `${protocol}://${host}:${port}`
}; exports.makeRestBaseURL = makeRestBaseURL

 const buildAuthProtocol = (auth) =>
  _base64.encode.call(void 0, JSON.stringify(auth)).replace(/=/g, ''); exports.buildAuthProtocol = buildAuthProtocol

 const makeExponentialDelay = (attempt) => {
  const base = Math.min(120, attempt ** 2) * 1000
  const jitter = (Math.random() * 100 - 50) * Math.min(1, attempt)

  return base + jitter
}; exports.makeExponentialDelay = makeExponentialDelay

const RECONNECT_BASE_MS = 1000
const RECONNECT_CAP_MS = 30000

// The wait before reconnect attempt `attempt + 1`. A socket that was open
// reconnects at once (attempt 0). After that it doubles from 1 s to a 30 s cap
// and draws from the upper half of the step, so clients that dropped together
// spread out instead of retrying in step.
 const makeReconnectDelay = (attempt) => {
  if (attempt <= 0) return 0
  const step = Math.min(RECONNECT_CAP_MS, RECONNECT_BASE_MS * 2 ** (attempt - 1))
  return step / 2 + Math.random() * step / 2
}; exports.makeReconnectDelay = makeReconnectDelay
